<template>
  <div class="overall-result-page-container" id="printme">
    <!-- <button @click="printWithCss">Print</button> -->

    <!-- <overall-result-wrap /> -->
    <div class="graphs__card">
      <div class="graphs__card-header">
        <!-- <span class="heading">
          Comparative analysis of Residential Envelope Transmittance Value (RETV)
        </span> -->
        <v-alert color="blue-grey" dark dense icon="mdi-chart-bar" prominent>
          Comparative analysis of Residential Envelope Transmittance Value (RETV)
        </v-alert>
      </div>

      <div class="graphs__card-wrap">
        <div class="graphs-row1">
          <div class="--m2">
            <retv-projects-chart class="charts-shadow" />
          </div>
          <div class="--m2">
            <retv-term-wise-graph class="charts-shadow" />
          </div>
        </div>

        <div class="graphs-row1">
          <div class="--m2">
            <interpretation-card />
          </div>
        </div>
      </div>
    </div>
    <!-- Card 2 -->
    <div class="graphs__card">
      <div class="graphs__card-header">
        <v-alert color="blue-grey" dark dense icon="mdi-chart-bar" prominent>
          Comparative analysis of thermal transmittance and Effective Solar Heat Gain Coefficient
        </v-alert>
      </div>
      <div class="graphs-row2">
        <div class="--m2">
          <thermal-roof-graph class="charts-shadow" />
        </div>
        <div class="--m2">
          <thermal-wall-graph class="charts-shadow" />
        </div>
      </div>
      <div class="graphs-row3">
        <div class="--m2">
          <thermal-glass-graph class="charts-shadow" />
        </div>
        <div class="--m2">
          <shgc-eff-graph class="charts-shadow" />
        </div>
      </div>
    </div>
    <!-- Overall Result Card -->
    <div class="overall-result-card">
      <div class="overall-result-header">Overall Result</div>
      <table class="overall-result-table">
        <thead>
          <tr>
            <td :colspan="projects.length + 1" class="table-heading-overall">RESULT: Comparative analysis of the input details</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="input__col-width" style="background-color:#FFF76A">Input Details</td>
            <td class="col-width" style="background-color:#FFF76A" v-for="(project, m) in projects">Project-{{ m + 1 }}</td>
          </tr>

          <tr>
            <td style="background-color:#dedede">
              Project Name
            </td>
            <td v-for="(project, m) in projects">{{ project.project_name }}</td>
          </tr>

          <tr>
            <td style="background-color:#dedede">
              Location
            </td>
            <td v-for="(project, m) in projects">{{ projects[m].schema.inputs.step1.project_location || `----` }}</td>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Latitude
            </td>
            <td v-for="(project, m) in projects">{{ projects[m].schema.inputs.step1.latitude.name || `----` }}</td>
          </tr>

          <tr>
            <td style="background-color:#dedede">
              Climate Zone
            </td>
            <td v-for="(project, m) in projects">{{ projects[m].schema.inputs.step1.climate_zone || `----` }}</td>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Surface Area Wall (sq.m)
            </td>
            <td v-for="(project, m) in projects">{{ projects[m].schema.inputs.step2.summary_step2.surface_area_wall }}</td>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              WWR%(only glass)
            </td>
            <td v-for="(project, m) in projects">{{ (project.schema.inputs.step4.vltObj.window_wall_ratio * 100).toFixed(2) }}</td>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Roof Construction Assembly
            </td>
            <template v-for="(project, m) in projects">
              <td>
                <template v-for="(roof, k) in projects[m].schema.inputs.step5A.thermal_trans_roof">
                  <div class="multi-line-results">
                    {{ roof.material_n_resistance.material || `----` }}
                  </div>
                </template>
              </td>
            </template>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Wall Construction Assembly
            </td>
            <template v-for="(project, m) in projects">
              <td>
                <!-- v-for="(wall, l) in schema.inputs.step5B.thermal_trans_walls" -->

                <template v-for="(wall, n) in projects[m].schema.wallConstructionAssemblyData">
                  <div class="multi-line-results">
                    {{ wall }}
                  </div>
                </template>
              </td>
            </template>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Door Frame Construction
            </td>
            <template v-for="(project, a) in projects">
              <td>
                <template v-for="(doorObj, b) in projects[a].schema.inputs.step5B.thermal_trans_doors">
                  <template v-for="layerObj in doorObj.layer_arr_obj">
                    <div class="multi-line-results">
                      {{ layerObj.material_n_resistance.material }}
                    </div>
                  </template>
                </template>
              </td>
            </template>
            <!-- </template> -->

            <!-- </template> -->
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Window Frame Construction
            </td>
            <template v-for="(project, c) in projects">
              <td>
                <template v-if="projects[c].schema.inputs.step5B.thermal_trans_windows.length > 0">
                  <template v-for="(windowObj, d) in projects[c].schema.inputs.step5B.thermal_trans_windows">
                    <template v-for="layerObj in windowObj.layer_arr_obj">
                      {{ layerObj.material_n_resistance.material }}
                    </template>
                  </template>
                </template>
                <template v-else>
                  -----
                </template>
              </td>
            </template>
          </tr>

          <tr>
            <td style="background-color:#dedede">
              Glazing Selection
            </td>
            <td v-for="(project, k) in projects">
              <template v-for="glazing in projects[k].schema.glazingSelectionData">
                <div class="multi-line-results">
                  {{ glazing }}
                </div>
              </template>
            </td>
          </tr>
          <tr>
            <td style="background-color:#dedede">
              Shading Selection
            </td>
            <template v-for="(project, d) in projects">
              <td>
                <template v-for="(shading, j) in projects[d].schema.shadingSelectionData">
                  <div class="multi-line-results">
                    {{ shading }}
                  </div>
                </template>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <!-- *** -->

      <table class="overall-result-conclusion-table">
        <thead>
          <tr>
            <td style="background-color: #c4def5">
              Results
            </td>

            <td style="background-color: #c4def5" v-for="project in projects">{{ project.project_name }}</td>
          </tr>
          <tr>
            <td>WFR(Openable)%</td>
            <td v-for="(project, p) in projects">{{ projects[p].schema.inputs.step4.wfropObj.wfropPercent || `----` }}</td>
          </tr>
          <tr>
            <td>VLT (recommended)</td>
            <td v-for="(project, p) in projects">{{ projects[p].schema.inputs.step4.vltObj.required_vlt || `----` }}</td>
          </tr>
          <tr>
            <td>Uroof (W/m2)</td>
            <td v-for="(project, p) in projects">{{ projects[p].schema.inputs.step5A.roof_u_value || `----` }}</td>
          </tr>
          <tr>
            <td>RETV (W/m2)</td>
            <template v-for="(project, p) in projects">
              <td :class="{ projectValid: projects[p].schema.inputs.retv6C.retv < 15, projectInvalid: projects[p].schema.inputs.retv6C.retv > 15 }">{{ projects[p].schema.inputs.retv6C.retv || `----` }}</td>
            </template>
          </tr>
        </thead>
      </table>
      <!-- **** -->
      <div class="helper-table-container">
        <table class="conclusion-helper-table">
          <tr>
            <td
              style="  background-color: #FFEBEB;
"
              class="helper-td"
            ></td>
            <td style="background-color:white">Not compliant</td>
          </tr>
          <tr>
            <td
              style="      background-color: #c8f0e0;
"
            ></td>
            <td>Compliant</td>
          </tr>
        </table>
      </div>
      <!-- **** -->
    </div>
  </div>
</template>

<script>
import OverallGraphs from './OverallGraphs.vue';
import RetvProjectsChart from './Graphs/RetvProjectsChart.vue';
import RetvTermWiseGraph from './Graphs/RetvTermWiseGraph.vue';
import ThermalRoofGraph from './Graphs/ThermalRoofGraph.vue';
import ThermalWallGraph from './Graphs/ThermalWallGraph.vue';
import ThermalGlassGraph from './Graphs/ThermalGlassGraph.vue';
import ShgcEffGraph from './Graphs/ShgcEffGraph.vue';
import InterpretationCard from './Graphs/InterpretationCard.vue';
import OverallResultWrap from './OverallResultWrap.vue';
export default {
  components: {
    OverallGraphs,
    RetvProjectsChart,
    RetvTermWiseGraph,
    ThermalRoofGraph,
    ThermalWallGraph,
    ThermalGlassGraph,
    ShgcEffGraph,
    InterpretationCard,
    OverallResultWrap,
  },
  data() {
    return {
      projectsRetv: [],
      project1retvTermWise: [],
      project2retvTermWise: [],
      project3retvTermWise: [],
      projectsURoof: [],
    };
  },
  computed: {
    projects: {
      get: function() {
        // console.log('Wall Index', this.wallIndex);
        return this.$store.state.projects;
      },
      set: function(Project) {
        this.$store.dispatch('setProjects', Project);
      },
    },
    //Project wise Retv
    projectWiseRetv() {
      this.projectsRetv = [];
      this.projects.forEach(project => {
        console.log('Project retv', project.schema.inputs.retv6C.retv);

        if (project.schema.inputs.retv6C.retv) {
          this.projectsRetv.push(project.schema.inputs.retv6C.retv);
        } else {
          this.projectsRetv.push(0);
        }
      });
      return this.projectsRetv;
    },
    //Retv term wise graphs

    calcProjectsURoof() {
      this.projectsURoof = [];
      this.projects.forEach((project, index) => {
        this.projectsURoof.push(project.schema.inputs.step5A.roof_u_value);
      });
      console.log('Projects URoof', this.projectsURoof);
      return this.projectsURoof;
    },
    wallConstructionAssembly() {
      const wallConstructionData = new Set();
      this.projects.forEach(project => {
        project.schema.inputs.step5B.thermal_trans_walls.forEach(wall => {
          wall.layer_arr_obj.forEach(layerObj => {
            if (layerObj.material_n_resistance) {
              wallConstructionData.add(layerObj.material_n_resistance.material);
            }
          });
        });
      });

      return wallConstructionData;
    },
  },
  mounted() {
    this.projects.forEach(project => {
      console.log(project.project_name, project.schema.wallConstructionAssemblyData);
    });
  },
  watch: {
    projects: {
      handler: function() {
        this.projectWiseRetv;
        // this.calcRetvTermWise;
        this.calcProjectsURoof;
      },
      immediate: true,
    },
  },
  methods: {
    printWithCss() {
      //Works with Chome, Firefox, IE, Safari
      //Get the HTML of div
      var title = document.title;
      var divElements = document.getElementById('printme').innerHTML;
      var printWindow = window.open('', '_blank', '');
      //open the window
      printWindow.document.open();
      //write the html to the new window, link to css file
      printWindow.document.write('<html><head><title>' + title + '</title><link rel="stylesheet" type="text/css" href="./OverallResult.scss"></head><body>');
      printWindow.document.write(divElements);
      printWindow.document.write('</body></html>');
      printWindow.document.close();
      printWindow.focus();
      //The Timeout is ONLY to make Safari work, but it still works with FF, IE & Chrome.
      setTimeout(function() {
        printWindow.print();
        printWindow.close();
      }, 100);
    },
  },
};
</script>

<style lang="scss">
.overall-result-page-container {
  margin-top: 100px;
  height: 100vh;
  padding: 12px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
}
.graphs__card {
  background-color: #fff;
  margin-bottom: 12px;
  .graphs__card-header {
    background-color: #e1f3f1;
    // padding: 12px 4px 12px 4px;
    .heading {
      color: #0d9b8e;
    }
  }
}

.overall-result-card {
  width: 100%;
  background-color: #fff;
  margin: auto;
  // height: 100%;
  .overall-result-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 24px;
  }
  .input__col-width {
    width: 12%;
  }
  .col-width {
    width: 28%;
  }
}
.graphs-row1 {
  display: flex;
  justify-content: space-evenly;
}
.charts-shadow {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 4px;
}
.graphs-row2,
.graphs-row3 {
  // margin: 16px 0px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.graphs-row3 {
  margin-bottom: 16px;
}
.overall-result-table,
.overall-result-conclusion-table {
  padding: 12px;
  width: 100%;
  border-radius: 4px;
  // border: 1px solid #a4abb3;
  border-spacing: 0px;
  .table-heading-overall {
    background-color: #c4def5;
    padding: 4px 16px;
    font-size: 20px;
    background-color: #c8f0e0;
    color: #2cb17c;
  }
  .multi-line-results-row {
    display: flex;
  }
  .multi-line-results {
    display: flex;
    flex-direction: column;
    // justify-content: flex-start;
  }
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 4px;
    text-align: center;
    font-size: 15px;
  }
}
.projectValid {
  background-color: #c8f0e0;
}
.projectInvalid {
  background-color: #ffebeb;
}
.helper-table-container {
  padding: 0 12px 12px 12px;
}
.conclusion-helper-table {
  border: 1px solid #a4abb3;
  padding: 8px;
  td {
    border: 1px solid #a4abb3;
    border-spacing: 0px;
    padding: 4px;
    text-align: center;
    font-size: 12px;
  }
  .helper-td {
    width: 24px;
  }
}
.--m2 {
  margin: 8px;
}
</style>
